export const common = {
  enumModel: '/common/enum/structure',
  myStoreList: '/common/list/store',
  createDynamicLink: `/common/create/dynamic`,
  hasUpdate: '/common/hasUpdate',
  splashIntroLog: '/common/log/splash-intro',
  productCategoryList: '/common/product/categories'
};
export const chat = {
  create: `/v1/chat/create`,
  getList: `/v1/chat/rooms`,
  detail: `/v1/chat/room`,
  chats: (no) => `/v1/chat/${no}/chats`,
  saveFile: `/v1/chat/file`,
  disabledRoom: (roomNo) => `/v1/chat/disabled/${roomNo}`,
  bubbleCount: (no) => `/v1/chat/bubble/${no}`,
  read: (roomNo, userNo) => `/v1/chat/read/${roomNo}/${userNo}`,
  badgeEmitter: (userNo) => `/v1/emitter/${userNo}`,
  orderEmitter: (userNo) => `/api/order/${userNo}`,
  leaveRoom: (roomNo, userNo) => `/v1/chat/leave/${roomNo}/${userNo}`,
  loadLast: (roomNo, lastBubbleNo) => `/v1/chat/load/${roomNo}/${lastBubbleNo}`
};
export const user = {
  renew: `/api/user/renew/token`,
  signIn: `/api/user/sign/in`,
  signOut: `/api/user/sign/out`,
  signUp: `/api/user/sign/up`,
  withdraw: `/api/user/withdraw`,
  findPwd: `/api/user/find/password`,
  findPwdResult: `/api/user/find/password/result`,
  findPwdChange: `/api/user/find/password/change`,
  request_email_authCode: '/api/user/find/password',
  checkDuplicate_email: '/api/user/isduplicate',
  changeLocale: (userNo, locale) => `/api/user/${userNo}/locale/${locale}`,
  push: `/api/user/set/push`,
  pushStatus: (userNo) => `/api/user/${userNo}/push-status`,
  voice: `/api/user/set/voice`,
  profile: `/api/user/profile`,
  doAuth: (userNo, phone) => `/api/user/auth/phone/${userNo}/${phone}`,
  requestPhoneAuth: '/api/user/auth/phone/request',
  verifyPhoneAuth: '/api/user/auth/phone/verify',
  requestSignupPhoneAuth: '/api/user/sign/up/phone/request',
  verifySignupPhoneAuth: '/api/user/sign/up/phone/verify',
  info: '/api/user/info',
  point: (userNo) => `/api/user/${userNo}/points`,
  coupons: (userNo) => `/api/user/${userNo}/coupons`,
  notifyOnlineStatus: (userNo) => `/api/user/notify/${userNo}/online-status`,
  checkIsActive: (userNo) => `/api/user/${userNo}/isActive`
};
export const main = {
  isStoreExist: '/api/store/is-exist',
  tag: '/api/tag',
  keyword: '/api/keyword',
  storeCategory: '/api/storeCategory',
  serviceArea: '/api/location',
  product_category: '/api/productCategory',
  banner: '/api/banner'
};
export const boardAPI = {
  faq: '/api/faq',
  event: '/api/event',
  event_detail: (eventNo) => `/admin/event/${eventNo}`,

  notice: '/api/notice',
  notice_detail: (noticeNo) => `/admin/notice/${noticeNo}`,

  inquiry: '/api/inquiry'
};
export const promotionAPI = {
  promotionList: '/api/promotion'
};
export const storeAPI = {
  storeList: '/api/store',
  store_detail: (storeNo) => `/api/store/${storeNo}`,
  store_favorite: (storeNo) => `/api/store/${storeNo}/favorite`,
  store_reviews: '/api/store/reviews',
  accumulate: '/api/store/accumulate',
  fav: '/api/store/fav',
  categories: (storeNo) => `/api/store/${storeNo}/product-categories`,
  categoryProducts: (storeNo, categoryNo) => `/api/store/${storeNo}/${categoryNo}`,
  products: (storeNo) => `/api/store/${storeNo}/products`,
  isOnline: (userNo) => `/api/store/is-online/${userNo}`,
  hit: (storeNo) => `/api/store/hit/${storeNo}`
};

export const admin_storeAPI = {
  my_shop: '/api/admin/shop',
  my_shop_detail: (storeNo) => `/api/admin/shop/${storeNo}`,
  update_business: '/api/admin/shop/save/business',

  payment_save: '/store/shop/save/payment',
  basic_save: '/api/admin/shop/save/basic',
  image_save: '/store/shop/save/images',
  business_save: '/api/admin/shop/save/business',
  delivery_save: '/api/admin/shop/save/delivery',

  dashboard_count: '/api/admin/dashboard/count',
  dashboard_sales: '/api/admin/dashboard/sales',
  dashboard_transaction: '/api/admin/dashboard/transaction',
  dashboard_classify: '/api/admin/dashboard/classify',
  dashboard_fav: (storeNo) => `/api/admin/dashboard/fav/${storeNo}`
};

export const admin_areaAPI = {
  points: (storeNo) => `/admin/serviceableArea/${storeNo}`
};

export const admin_couponAPI = {
  issue_list: '/api/admin/coupon',
  issue_history: '/store/coupon/histories',
  coupon_save: '/api/admin/coupon/save',
  coupon_issue: '/api/admin/coupon/issue',
  coupon_delete: (couponNo) => `/api/admin/coupon/${couponNo}`
};

export const admin_reviewAPI = {
  review_list: `/api/admin/review`,
  review_detail: (reviewNo) => `/api/admin/review`,
  review_update_pin: (storeNo, reviewNo, state) => `/api/admin/review/${storeNo}/pin/${reviewNo}/${state}`,
  report: '/api/admin/review/report',
  reply: '/api/admin/review/repl',
  reply_save: '/api/admin/review/save'
};

export const admin_favoriteAPI = {
  store_list: `/api/my/favorite/store`,
  product_list: `/api/my/favorite/product`,
  like_store: (userNo, storeNo) => `/api/my/${userNo}/store/${storeNo}`, // POST
  like_product: (userNo, productNo) => `/api/my/${userNo}/product/${productNo}`, // POST,
  hate_store: (userNo, storeNo) => `/api/my/${userNo}/store/${storeNo}`,
  hate_product: (userNo, productNo) => `/api/my/${userNo}/product/${productNo}`
};

export const admin_orderAPI = {
  order_list: '/store/order',
  change_state: '/api/admin/order/status',
  order_rank: '/api/admin/order/rank'
};

export const admin_customerAPI = {
  customer_list: '/api/admin/customer',
  customer_detail: (storeNo, userNo) => `/api/admin/customer/${storeNo}/${userNo}`,
  customer_save: '/api/admin/customer/save'
};
export const productAPI = {
  product_list: '/api/admin/product',
  product_detail: (productNo) => `/api/admin/product/${productNo}`,

  category_list: '/api/productCategory',
  product_save: '/api/admin/product/save',
  product_delete: (productNo) => `/api/admin/product/${productNo}`,

  search_products: '/api/store/products'
};
export const orderAPI = {
  lastBestOrderList: '/api/last/best'
};
export const addressAPI = {
  address_list: '/api/my/addresses',
  set_primary: (userNo, addressNo) => `/api/my/address/primary/${userNo}/${addressNo}`,
  delete: (addressNo) => `/api/my/address/remove/${addressNo}`,
  save: `/api/my/address/save`
};

/**
 * search 페이지 API
 * @type {{recommendedKeyword: string, recentSearchKeyword: string}}
 */
export const searchAPI = {
  recentSearchKeyword: '/api/searchKeyword',
  recommendedKeyword: '/api/keyword',
  keywordRank: '/api/popular',
  save_keywordCollection: '/api/popular'
};

export const myPageAPI = {
  point_list: '/api/my/points',
  point_total: (userNo) => `/api/my/${userNo}/totalPoint`,

  coupon_list: '/api/my/coupons',
  coupon_total: (userNo) => `/api/my/${userNo}/totalCoupon`,

  review_list: '/api/my/reviews',
  review_save: '/api/my/save/review',
  review_delete: (reviewNo) => `/api/my/remove/review/${reviewNo}`,

  order_list: '/api/my/orders',
  order_detail: (orderNo) => `/api/admin/order/${orderNo}`,
  order_delete: (orderNo) => `/api/my/hide/order/${orderNo}`
};

export const csAPI = {
  inquiry_list: '/api/cs',
  inquiry_save: '/api/cs/save',
  faq_list: '/api/faq',
  detail: (csNo) => `/api/cs/${csNo}`
};

export const preparePaymentAPI = {
  order: '/api/order',
  carts: '/api/order/carts',
  check: '/api/order/check/available',
  check_stock: '/api/order/check/stock',
  status: (no) => `/api/megapay/${no}/status`,
  isFinish: (no) => `/api/megapay/${no}`,
  cancel: (orderNo) => `/api/order/${orderNo}`
};

export const bizmoneyAPI = {
  bizmoney_transaction_list: '/api/admin/bizLog',
  bizmoney_request_list: '/api/admin/request',
  bizmoney_charge: '/api/admin/request/save'
};

export const bizNotificationAPI = {
  total_noti: '/api/my/push',
  detail_noti: (pushNo) => `/admin/push/${pushNo}`,
  notifications: '/api/admin/bizNotification'
};
